const API_PREFIX = "api";

export default {
  sub_admin_module: {
    sub_admin: API_PREFIX + "/admin",
    changeSubAdminStatus: API_PREFIX + "/admin/change-status"
  },
  auth: {
    forgot_password: API_PREFIX + "/admin/forget-password",
    reset_password: API_PREFIX + "/admin/reset-password"
  },
  terms_condition_module: {
    term_conditions: API_PREFIX + "/term-condition",
    changeTermConditionStatus: API_PREFIX + "/term-condition/change-status"
  },
  agent_module: {
    agent: API_PREFIX + "/agent",
    changeAgentStatus: API_PREFIX + "/agent/change-status"
  },
  agency_module: {
    agency: API_PREFIX + "/agency",
    changeAgencyStatus: API_PREFIX + "/agency/change-status"
  },
  region_module: {
    region: API_PREFIX + "/region",
    ChangeRegionStatus: API_PREFIX + "/region/change-status"
  },
  service_module: {
    services: API_PREFIX + "/service",
    ChangeServiceStatus: API_PREFIX + "/service/change-status"
  },
  supplier_module: {
    supplier: API_PREFIX + "/supplier",
    changeSupplierStatus: API_PREFIX + "/supplier/change-status"
  },
  service_type_module: {
    service_type: API_PREFIX + "/serviceType",
    changeServiceTypeStatus: API_PREFIX + "/serviceType/change-status"
  },
  event_module: {
    event: API_PREFIX + "/event",
    changeEventStatus: API_PREFIX + "/event/change-status"
  },
  // hotels
  hotel_module: {
    hotel: API_PREFIX + "/hotel",
    changeHotelStatus: API_PREFIX + "/hotel/change-status"
  },
  itinerary_module: {
    itinerary: API_PREFIX + "/itinerary",
    years: API_PREFIX + "/itinerary/years",
    filter: API_PREFIX + "/itinerary/get/owner-list",
    generate_quotation: API_PREFIX + "/itinerary/pdf",
    generate_invoice: API_PREFIX + "/itinerary/invoice/pdf",
    itinerary_download: API_PREFIX + "/itinerary/event/pdf",
    changeItineraryStatus: API_PREFIX + "/itinerary/change-status",
    exportBd: API_PREFIX + "/itinerary/export-bd",
    aves: API_PREFIX + "/itinerary/aves",
    push_to_axus: API_PREFIX + "/itinerary/push-to-axus",
    push_to_travefy: API_PREFIX + "/itinerary/push-to-travefy",
    get_axus_travefy_accounts: API_PREFIX + "/account/all"
  },
  image: {
    fetch_image_url: API_PREFIX + "/admin/fetch-image-url",
    fetch_multiple_image_url: API_PREFIX + "/multiple-upload?image"
  },
  message_module: {
    message: API_PREFIX + "/message",
    message_threads: API_PREFIX + "/message/threads"
  },
  dashboard_module: {
    notification: API_PREFIX + "/notification",
    changeNotificationStatus: API_PREFIX + "/notification/change-status"
  },
  user: {
    user_role: API_PREFIX + "/admin/user-role"
  }
};
